import { Routes, Route, Link } from 'react-router-dom'
import { Dashboard } from './pages/Dashboard'
import { Configuration } from './pages/Configuration'
import { ProjectDashboard } from './pages/ProjectDashboard'
import { Guide } from './pages/Guide'
import { FailingTests } from './pages/FailingTests'
import { ThemeSwitcher } from './components/ThemeSwitcher'
import { VersionBadge } from './components/VersionBadge'
import { UserMenu } from './components/UserMenu'
import { AuthProvider } from './context/AuthContext'
import { I18nProvider, useTranslation } from './i18n'

function AppContent() {
  const { t } = useTranslation()

  return (
    <div className="app">
      <header className="app-header">
        <nav className="nav">
          <Link to="/" className="nav-brand">
            <img src="/logo-icon.svg" alt="Smarter Software" className="nav-logo" />
            <span>{t('page.dashboard')}</span>
            <VersionBadge />
          </Link>
          <div className="nav-links">
            <Link
              to="/"
              className="nav-link"
              data-testid="nav-dashboard"
              aria-label={t('nav.dashboard')}
            >
              <i className="pi pi-chart-bar" aria-hidden="true" />
              <span>{t('nav.dashboard')}</span>
            </Link>
            <Link
              to="/projects"
              className="nav-link"
              data-testid="nav-projects"
              aria-label={t('nav.projects')}
            >
              <i className="pi pi-folder" aria-hidden="true" />
              <span>{t('nav.projects')}</span>
            </Link>
            <Link
              to="/config"
              className="nav-link"
              data-testid="nav-config"
              aria-label={t('nav.configuration')}
            >
              <i className="pi pi-cog" aria-hidden="true" />
              <span>{t('nav.configuration')}</span>
            </Link>
            <Link
              to="/guide"
              className="nav-link"
              data-testid="nav-guide"
              aria-label={t('nav.guide')}
            >
              <i className="pi pi-question-circle" aria-hidden="true" />
              <span>{t('nav.guide')}</span>
            </Link>
            <ThemeSwitcher />
            <UserMenu />
          </div>
        </nav>
      </header>
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/failing" element={<FailingTests />} />
          <Route path="/projects" element={<ProjectDashboard />} />
          <Route path="/config" element={<Configuration />} />
          <Route path="/config/projects/:projectId" element={<Configuration />} />
          <Route path="/guide" element={<Guide />} />
        </Routes>
      </main>
    </div>
  )
}

export function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </I18nProvider>
  )
}
